import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/Buttons/button";

const ProfileUnavailable = () => {
  const navigation = useNavigate();

  const goHome = () => {
    navigation("/");
  };

  return (
    <div className="profile-unavailable">
      <div className="container">
        <div className="card-ui mb-24">
          <div className="card-ui__box">
            <div className="card-ui__box__head text-center">
              <div className="icon purple">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
                  <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                </svg>
              </div>
              <h4 className="mb-20">Profile No Longer Available</h4>
              <p>This profile is currently unavailable. Please select another profile to continue exploring.</p>
            </div>
            <div className="card-ui__box__foo flex flex-align-center flex-justify-center">
              <Button text={"Explore Other Profiles"} onClick={goHome} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileUnavailable;
